[
  {
    "code": "GB-ENG",
    "name": "England"
  },
  {
    "code": "GB-NIR",
    "name": "Northern Ireland"
  },
  {
    "code": "GB-SCT",
    "name": "Scotland"
  },
  {
    "code": "GB-WLS",
    "name": "Wales"
  }
]